export default __webpack_public_path__ + "static/media/os_windows.a282fb07.svg";